<script>
	import { selectedProvider, serviceProviders } from "../store";

	function handleChange(event) {
		const newProvider = $serviceProviders.find(
			(provider) => event.target.value === provider.name
		);
		$selectedProvider = newProvider || null;
	}
</script>

<div>
	<label class="psl-label" for="service-provider">Palveluntarjoaja:</label>
	<select
		class="psl-select"
		name="service-provider"
		id="service-provider"
		on:change={handleChange}
	>
		<option value="">Valitse palveluntarjoaja</option>
		{#each $serviceProviders as provider}
			<option value={provider.name}>{provider.name}</option>
		{/each}
	</select>
</div>

<style>
	div {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin-top: 0;
	}
</style>
